import { render } from "./FAQ.vue?vue&type=template&id=283066b4"
const script = {}

import "./FAQ.vue?vue&type=style&index=0&id=283066b4&lang=css"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__